export enum SecondaryUptimeStatus {
    Up = "Up",
    Down = "Down",
    Unknown = "Unknown"
}
